import Cookies from 'js-cookie';
// Cache pro konfiguraci
let configCache = null;
// Funkce pro získání konfigurace z cookies
function _getConfig() {
    if (configCache) {
        return configCache;
    }
    const base64Config = Cookies.get('dek_config');
    if (!base64Config)
        throw new Error('DEK Config was not found.');
    try {
        const jsonConfig = atob(base64Config);
        const parsedConfig = JSON.parse(jsonConfig);
        configCache = parsedConfig;
        return configCache;
    }
    catch (error) {
        throw new Error(`Invalid DEK Config: ${error instanceof Error ? error.message : 'Unknown error'}`);
    }
}
// Funkce pro získání výchozích HTTP hlaviček s autentizačním tokenem
function _getDefaultHeaders() {
    const token = Cookies.get('dek_eshop_token');
    if (!token)
        throw new Error('DEK Eshop token was not found.');
    const defaultHeaders = new Headers({
        Authorization: 'Bearer ' + token,
    });
    return defaultHeaders;
}
// Funkce pro vytvoření URL adresy s podporou parametrů vyhledávání
function _createUrl(apiEndpointOrOrigin = undefined, path, search = undefined) {
    // Získání konfigurace z cache nebo cookies
    const config = _getConfig();
    // Validace cesty - kontrola, zda je cesta validní a není prázdná
    if (!path || typeof path !== 'string') {
        throw new Error('Invalid path parameter');
    }
    let apiEndpoint;
    try {
        // Logika výběru základní URL adresy:
        // 1. Pokud není specifikována, použije se výchozí base URL z konfigurace
        // 2. Pokud je specifikována a existuje v konfiguraci, použije se odpovídající URL
        // 3. Pokud je specifikována a je 'eshop', použije se origin URL
        // 4. Jinak se použije přímo zadaná URL (musí být validní)
        if (apiEndpointOrOrigin === undefined) {
            apiEndpoint = config.api.base;
        }
        else if (apiEndpointOrOrigin in config.api) {
            apiEndpoint = config.api[apiEndpointOrOrigin];
        }
        else if (apiEndpointOrOrigin === 'eshop') {
            apiEndpoint = window.location.origin;
        }
        else {
            // Validace formátu URL - kontrola, zda je zadaná URL ve správném formátu
            new URL(apiEndpointOrOrigin);
            apiEndpoint = apiEndpointOrOrigin;
        }
        // Vytvoření nové URL adresy kombinací základní URL a cesty
        const url = new URL(path, apiEndpoint);
        // Přidání parametrů vyhledávání:
        if (search) {
            const sanitizedSearch = new URLSearchParams();
            search.forEach((value, key) => {
                if (value && key) {
                    // Kódování klíče i hodnoty pro bezpečné použití v URL
                    sanitizedSearch.append(key, value);
                }
            });
            // Přidání sanitizovaných parametrů do URL
            url.search = sanitizedSearch.toString();
        }
        return url;
    }
    catch (error) {
        // Zachycení a zpracování chyb při vytváření URL
        throw new Error(`Invalid URL configuration: ${error instanceof Error ? error.message : 'Unknown error'}`);
    }
}
// Funkce pro přidání výchozích HTTP hlaviček k požadavku
function _addDefaultHeaders(options) {
    const _o = { ...options };
    const extHeaders = new Headers(_o.headers);
    try {
        _o.headers = _getDefaultHeaders();
        // Sloučení externích hlaviček s výchozími
        extHeaders.forEach((value, key) => {
            if (value && key) {
                _o.headers?.set(key, value);
            }
        });
        // Přidání výchozího Content-Type, pokud je povoleno
        if (options.defaultContentType ?? true) {
            _o.headers.set('Content-Type', 'application/json');
        }
        return _o;
    }
    catch (error) {
        throw new Error(`Failed to add default headers: ${error instanceof Error ? error.message : 'Unknown error'}`);
    }
}
export { _getConfig, _getDefaultHeaders, _createUrl, _addDefaultHeaders, };
